// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nudKOd6PA4wSLGopGXyc{width:100%;height:100%;display:flex;gap:4em;flex-direction:column;justify-content:center;align-items:center}.nudKOd6PA4wSLGopGXyc .lYMXBWuhuEUE6ePGPZSR{flex:0 1 2em;width:80%}.nudKOd6PA4wSLGopGXyc .vi1V8_zwc1HpRxvEnKeX{width:80%;display:flex;flex-direction:row;gap:2em;justify-content:center}.nudKOd6PA4wSLGopGXyc .vi1V8_zwc1HpRxvEnKeX .d_u4HQ5PbZ0KNhwnR8Mn{flex:0 0 1px;background-color:#d0dae9}.nudKOd6PA4wSLGopGXyc .vi1V8_zwc1HpRxvEnKeX .Js6NWjuWzvtVgEwafhEQ{display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;width:100%;gap:2em}.nudKOd6PA4wSLGopGXyc .vi1V8_zwc1HpRxvEnKeX .Js6NWjuWzvtVgEwafhEQ h2{text-transform:uppercase}.nudKOd6PA4wSLGopGXyc .vi1V8_zwc1HpRxvEnKeX .Js6NWjuWzvtVgEwafhEQ .bnPqi3o2Mag9qYK99QS9{width:100%;border-bottom:1px solid #826ef5}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"pageWrapper": `nudKOd6PA4wSLGopGXyc`,
	"infoBoxWrapper": `lYMXBWuhuEUE6ePGPZSR`,
	"blocksWrapper": `vi1V8_zwc1HpRxvEnKeX`,
	"verticalLine": `d_u4HQ5PbZ0KNhwnR8Mn`,
	"blockWrapper": `Js6NWjuWzvtVgEwafhEQ`,
	"descriptionWrapper": `bnPqi3o2Mag9qYK99QS9`
};
export default ___CSS_LOADER_EXPORT___;
